import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faArrowRight, faPhoneVolume, faEnvelope, faLocationDot, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import footerLogo from '../assets/images/footer-logo.png';

const Footer = () => {
    const { t } = useTranslation();
    return (
        <section className="footer-con position-relative float-left w-100 main-box">
            <Container>
                <div className="middle_portion">
                    <Row>
                        <Col xl={3} lg={3} md={12}>
                            <div className="logo-content">
                                <a href="/"><img src={footerLogo} alt="footer logo" className="img-fluid footer-logo" /></a>
                                <p className="text-size-16 text">{t('footer_desc')}</p>
                                <ul className="list-unstyled mb-0 social-icons">
                                    <li><a href="https://facebook.com" className="text-decoration-none"><FontAwesomeIcon icon={faFacebookF} /></a></li>
                                    <li><a href="https://instagram.com" className="text-decoration-none"><FontAwesomeIcon icon={faInstagram} /></a></li>
                                    <li><a href="https://linkedin.com" className="text-decoration-none"><FontAwesomeIcon icon={faLinkedinIn} /></a></li>
                                </ul>
                            </div>
                        </Col>
                        <Col xl={2} lg={2} md={3} sm={6} xs={5}>
                            <div className="links">
                                <h4 className="heading">{t('footer_nav_title')}</h4>
                                <ul className="list-unstyled mb-0">
                                    <li><FontAwesomeIcon icon={faArrowRight} /><a href="/about">{t('nav_about')}</a></li>
                                    <li><FontAwesomeIcon icon={faArrowRight} /><a href="/services">{t('nav_services')}</a></li>
                                    <li><FontAwesomeIcon icon={faArrowRight} /><a href="/faq">Faq</a></li>
                                    <li><FontAwesomeIcon icon={faArrowRight} /><a href="/pricing">{t('nav_pricing')}</a></li>
                                </ul>
                            </div>
                        </Col>
                        <Col xl={3} lg={3} md={4} sm={6} xs={7}>
                            <div className="icon">
                                <h4 className="heading">{t('footer_contact_title')}</h4>
                                <ul className="list-unstyled mb-0">
                                    <li className="text"><FontAwesomeIcon icon={faPhoneVolume} /><a href="tel:+61383766284">+61 3 8376 6284</a></li>
                                    <li className="text"><FontAwesomeIcon icon={faEnvelope} /><a href="mailto:info@chatnex.com">info@chatnex.com</a></li>
                                    <li className="text"><FontAwesomeIcon icon={faLocationDot} /><span>{t('footer_address')}</span></li>
                                </ul>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={5}>
                            <div className="email-form">
                                <h4 className="heading">{t('footer_newsletter_title')}</h4>
                                <Form>
                                    <InputGroup className="mb-3">
                                        <Form.Control type="email" placeholder={t('footer_newsletter_placeholder')} aria-label={t('footer_newsletter_placeholder')} className="form_style"/>
                                        <Button type="submit" variant="primary" className="send"><FontAwesomeIcon icon={faPaperPlane} /></Button>
                                    </InputGroup>
                                    <Form.Group controlId="term" className="check-box mb-0">
                                        <Form.Check type="checkbox" label={<span>{t('footer_agree_text')} <a href="/privacy-policy">{t('footer_privacy_policy')}</a>.</span>}/>
                                    </Form.Group>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="copyright"><p className="mb-0">{t('footer_copyright')}</p></div>
            </Container>
        </section>
    );
};
export default Footer;